import './AbookpickerItem.scss';
import React from 'react';
import Chip from '@atoms/Chip';
import clsx from 'clsx';
import { IChipProps } from '@atoms/Chip/Chip';
import { IAddressBookData } from '@models/addressbook/IAddressBookData';

export interface IAbookpickerItemProps extends Omit<IChipProps, 'children' | 'onRemove'> {
    /** Список адрес бук элементов */
    item?: IAddressBookData;
    /** Показывать иконку удаления
     * @default true
     */
    showRemoveIcon?: boolean;
    /** Функция удаления элемента */
    onRemove?: (item: IAddressBookData) => void;
    /** Класс */
    className?: string;
}

const AbookpickerItem = ({ item, showRemoveIcon = true, onRemove, className, ...props }: IAbookpickerItemProps) => {
    if (!item) {
        return null;
    }

    return (
        <div className={clsx('rf-abookpickeritem', className)}>
            <Chip
                size="s"
                type="outline"
                maxLength={30}
                tooltipBackground={'white'}
                onRemove={showRemoveIcon ? () => onRemove?.(item) : undefined}
                iconPosition="right"
                {...props}
            >
                {item.fullName}
            </Chip>
        </div>
    );
};

export default AbookpickerItem;
